module.exports = __webpack_public_path__ + "img/t4-c4.2529d9aa.png";